<form [formGroup]="form">

  <!-- Title -->
  <mat-form-field [hidden]="!showTitle" floatLabel="always" class="mc-form-field mc-form-field-custom-input mc-form-field-compact" mcColor="secondary">
    <mat-label>Title</mat-label>
    <input #inputTitle matInput formControlName="title" [readonly]="readonly" type="text">
    <!-- Insert variable -->
    <button *ngIf="!(readonly$ | async)" matIconSuffix mat-icon-button type="button" color="secondary" matTooltip="Insert variable" (click)="insertVariables(inputTitle)">
      <mat-icon fontSet="project-titan" fontIcon="icon-variable-tree-view"></mat-icon>
    </button>
  </mat-form-field>

  <!-- Stylesheets -->
  <mat-form-field floatLabel="always" class="mc-form-field mc-form-field-custom-input mc-form-field-compact" mcColor="secondary">
    <mat-label>Stylesheets</mat-label>
    <mc-project-file-picker-input #stylesheetInputs *ngIf="!readonly; else readonlyStylesheets" formControlName="stylesheets" placeholder="(default)" class="mc-topic-properties-file-picker-input" [isPathWithLeadingSlash]="true" rootFolder="Content" [projectId]="projectId" [branchName]="branchName" [fileFilter]="StylesheetsFileFilter" [usingWorkspaceTree]="usingWorkspaceTree" multiple="true">
    </mc-project-file-picker-input>
    <mc-dropdown-arrow matIconSuffix></mc-dropdown-arrow>
    <mat-error>
      <mc-form-control-error-message [form]="form" controlName="stylesheets" type="mc_property"></mc-form-control-error-message>
    </mat-error>
    <ng-template #readonlyStylesheets>
      <input matInput formControlName="stylesheets" placeholder="(default)" readonly="true" type="text" class="mc-topic-properties-readonly-file-picker-input" mcArrayToString mcArrayToStringSeparator="; ">
    </ng-template>
  </mat-form-field>

  <!-- Template Page -->
  <mat-form-field [hidden]="!showTemplatePage" floatLabel="always" class="mc-form-field mc-form-field-custom-input mc-form-field-compact" mcColor="secondary">
    <mat-label>Template Page</mat-label>
    <mc-project-file-picker-input #templatePageInput *ngIf="!readonly; else readonlyTemplatePage" formControlName="templatePage" placeholder="(default)" class="mc-topic-properties-file-picker-input" [isPathWithLeadingSlash]="true" rootFolder="Content" [projectId]="projectId" [branchName]="branchName" [fileFilter]="TemplatePageFileFilter" [usingWorkspaceTree]="usingWorkspaceTree">
    </mc-project-file-picker-input>
    <mc-dropdown-arrow matIconSuffix></mc-dropdown-arrow>
    <mat-error>
      <mc-form-control-error-message [form]="form" controlName="templatePage" type="mc_property"></mc-form-control-error-message>
    </mat-error>
    <ng-template #readonlyTemplatePage>
      <input matInput formControlName="templatePage" placeholder="(default)" readonly="true" type="text" class="mc-topic-properties-readonly-file-picker-input">
    </ng-template>
  </mat-form-field>

  <!-- Searchable -->
  <div class="mc-topic-properties-checkbox-wrapper" [hidden]="!showSearchable">
    <mat-checkbox color="accent-vivid" [class.mc-topic-properties-checkbox]="!readonly" formControlName="searchable">Searchable</mat-checkbox>
    <mc-help-icon-button>
      <div class="mc-topic-properties-help">
        <p>Include topic when full-text search database is generated.</p>
        <p>This feature is available only for HTML5 and WebHelp targets.</p>
      </div>
    </mc-help-icon-button>
  </div>

</form>